import { Container, Grid, Parse, Section } from '@/components/Core'
import { TeamMemberFragment } from '@/lib/fragments'
import { Lib } from '@/types'
import clsx from 'clsx'
import { memo } from 'react'
import Client from './index.client'
import SectionSliderFragment from './query'
export interface SectionSliderProps {
  data: Lib.FragmentOf<typeof SectionSliderFragment>
}

export type Variant = 'default' | 'team'
export type TeamMember = Lib.FragmentOf<typeof TeamMemberFragment>[]

const SectionSlider = ({ data }: SectionSliderProps) => {
  const {
    variant,
    hide,
    bg,
    title,
    titleRight,
    titleFirstSlide,
    content,
    _modelApiKey
  } = data

  const _variant = variant as Variant

  const sectionClass = clsx(
    'py-md overflow-hidden relative',
    hide && 'hidden',
    bg && 'bg-neutral-300'
  )

  return (
    <Section
      className={sectionClass}
      sectionName={_modelApiKey}
      anim="section-fade-in"
    >
      {titleFirstSlide && (
        <Container className="pt-vertical-main md:hidden">
          <Grid>
            {titleFirstSlide && (
              <div className="col-span-12 lg:col-span-4 lg:col-start-2">
                <h2 className="h4">{titleFirstSlide}</h2>
              </div>
            )}
          </Grid>
        </Container>
      )}
      {(title || titleRight || content) && (
        <Container className="pt-vertical-main">
          <Grid>
            {title && (
              <div className="col-span-12 lg:col-span-4 lg:col-start-2">
                <h2 className="h4">{title}</h2>
              </div>
            )}
            {data?.titleFirstSlide && (
              <div className="col-span-12 lg:col-span-4 lg:col-start-2">
                <h2 className="h4">{data.titleFirstSlide}</h2>
              </div>
            )}
            <div className="gap-vertical-small col-span-12 flex flex-col lg:col-span-6">
              {titleRight && (
                <div className={'text-style-large'}>{titleRight}</div>
              )}
              {content && (
                <div className={'prose max-w-full'}>
                  <Parse html={content} />
                </div>
              )}
            </div>
          </Grid>
        </Container>
      )}
      <Container className="overflow-visible px-0">
        <Client data={data} variant={_variant} />
      </Container>
    </Section>
  )
}

export default memo(SectionSlider)
